import React from "react";
import "../../css/Footer.css";
import { ReactComponent as PhoneIcon } from "../../assets/icons/call.svg";
import { ReactComponent as LocationIcon } from "../../assets/icons/email.svg";
import { Link, useNavigate } from "react-router-dom";

function Footer() {
  const navigate = useNavigate();
  return (
    <footer className="footer">
      {/* Legal Footer */}
      <div className="content footer-legal">
        <div style={{ marginBottom: "20px" }}>
          <strong>
            EDWARDCOOMBS LTD is an Appointed Representative of Rosemount
            Financial Solutions (IFA) Limited which is authorised and regulated
            by the Financial Conduct Authority. Rosemount Financial Solutions
            (IFA) Limited is entered on the Financial Services Register under
            reference 535515.
          </strong>
          <br />
          <strong>
            EDWARDCOOMBS LTD is registered in England and Wales (Company Number:
            16407001). Registered Address: 71-75 Shelton Street, Covent Garden,
            London, United Kingdom,{" "}
            <span style={{ whiteSpace: "nowrap" }}>WC2H 9JQ.</span> The
            information on this website is subject to the UK regulatory regime
            and is intended for consumers in the UK.
          </strong>
        </div>
        <div className="content secondary"
          onClick={() => navigate("/privacy-policy")}
          style={{ cursor: "pointer", textDecoration: "underline" }}
        >
          Read the Privacy Policy here.
        </div>
      </div>
    </footer>
  );
}

export default Footer;
